export default __webpack_public_path__ + "locales/tr/ConnectDialog.json?hash=7cd05ac09006ba5ed3dbf26897f11ca3";